import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import VideoDetail from '@/components/VideoDetail'
import CovidMap from '@/components/CovidMap'
import Privacy from '@/components/Privacy'
import Terms from '@/components/Terms'
import PageError from '@/components/Error'
import state from '../store/state'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/map',
            name: 'CovidMap',
            component: CovidMap
        },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/video/:id',
            name: 'VideoDetail',
            component: VideoDetail
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        },
        {
            path: '/terms',
            name: 'Terms',
            component: Terms
        },
        {
            path: '/error',
            name: 'PageError',
            component: PageError
        },
        {
            path: '/logout',
            redirect: to => {
                localStorage.removeItem('user_token')
                localStorage.removeItem('user_token_ts')
                state.userInfo = false
                return { path: '/' }
            }
        },
        {
            path: '/chatroomadmin',
            name: 'ChatRoomAdmin',
            component: () => import('@/components/ChatContent')
        },
        {
            path: '/mine',
            name: 'Mine',
            component: () => import('@/components/Profile')
        },
        {
            path: '/mineSetting',
            name: 'MineSetting',
            component: () => import('@/components/MineSetting')
        },
        {
            path: '/shareVideo',
            name: 'ShareVideo',
            component: () => import('@/components/ShareVideo')
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('@/components/TopAlert')
        },
        {
            path: '*',
            redirect: to => {
                return { path: '/error', query: {code: 404} }
            }
        }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.query.token) {
        localStorage.setItem('user_token', to.query.token)
        localStorage.setItem('user_token_ts', new Date().getTime())
        let newPath = to.fullPath.replace('token=' + to.query.token, '')
        next(newPath)
    } else if (to.query.code && !state.userInfo) {
        localStorage.setItem('referrer_code', to.query.code)
        let newPath = to.fullPath.replace('&code=' + to.query.code, '')
        next(newPath)
    } else {
        if (to.path === '/chatroomadmin') {
            if (to.query.adminToken && to.query.adminToken === state.adminToken) {
                next()
            } else {
                next('/')
            }
        } else {
            next()
        }
    }
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js